import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewEncapsulation
} from "@angular/core";
import {AbstractWizardComponent, Wizard, WizardStepFactory} from "../../../../../../common/interfaces/wizard.interface";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {PartnerProceduresWizardUpdateSerialComponent} from "./update-serial/update-serial.component";
import {
    PartnerProceduresWizardAddSerialComponent,
    PartnerProceduresWizardRemoveSerialComponent,
    PartnerProceduresWizardSerialToQtyComponent,
    PartnerProceduresWizardTypeComponent,
    PartnerProceduresWizardUpdateBatchComponent,
    PartnerProceduresWizardUpdateBoxHubComponent,
    PartnerProceduresWizardUpdateHubComponent,
    PartnerProceduresWizardUpdateItemComponent,
    PartnerProceduresWizardUpdateItemForSerialComponent,
    PartnerProceduresWizardUpdateConfigurationForSerialComponent,
    PartnerProceduresWizardUnlinkSerialFromBoxComponent,
    PartnerProceduresWizardLinkSerialToBoxComponent,
    PartnerProceduresWizardBoxRefChangeComponent,
    PartnerProceduresWizardPalletRefChangeComponent, PartnerProceduresWizardUpdatePalletHubComponent
} from "./index";
import {PartnerProceduresWizardUpdateQuantityComponent} from "./update-quantity/update-quantity.component";
import {PartnerProceduresWizardTransferUpdatePalletComponent} from "./update-pallet/update-pallet.component";
import {Api} from "../../../../../../common/services/api.service";
import {Api3Service} from "../../../../../../common/services/api3.service";

@Component({
    selector: "section-partner-procedures",
    templateUrl: "wizard.component.html",
    styleUrls: [
        "./wizard.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})

export class PartnerProceduresWizardComponent extends AbstractWizardComponent implements OnInit {

    private allowed_mrbs: string[] = [];
    public status: any;

    public constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        private api3Service: Api3Service
    ) {
        super(changeDetectorRef);
    }

    private async getPartnerMrbs(): Promise<any> {

        const {data}: Api.IResponse = await this.api3Service.get(`${this.state.section}/mrb/allowed`);

        if (data) {
            this.allowed_mrbs = data;
            this.changeDetectorRef.markForCheck();
        }
    }


    protected handleSetupEvent(event: Wizard.IStepResult, stepIndex: number): void {
        if (this.steps[stepIndex].title === "Scan type") {
            this.steps.splice(1);
            if (event.value === "serial-add") {
                this.steps.push(
                    new WizardStepFactory("Add serial", PartnerProceduresWizardAddSerialComponent));
            } else if (event.value === "serial-change") {
                this.steps.push(
                    new WizardStepFactory("Update serial", PartnerProceduresWizardUpdateSerialComponent));
            } else if (event.value === "serial-remove") {
                this.steps.push(
                    new WizardStepFactory("Remove serial", PartnerProceduresWizardRemoveSerialComponent));
            } else if (event.value === "item-change") {
                this.steps.push(
                    new WizardStepFactory("Replace part number in inventory",
                        PartnerProceduresWizardUpdateItemComponent));
            } else if (event.value === "quantity-change") {
                this.steps.push(
                    new WizardStepFactory("Update item quantity", PartnerProceduresWizardUpdateQuantityComponent));
            } else if (event.value === "hub-change") {
                this.steps.push(
                    new WizardStepFactory("Hub transfer", PartnerProceduresWizardUpdateHubComponent));
            } else if (event.value === "box-hub-change") {
                this.steps.push(
                    new WizardStepFactory("Box sub inventory transfer", PartnerProceduresWizardUpdateBoxHubComponent));
            } else if (event.value === "item-change-serial") {
                this.steps.push(
                    new WizardStepFactory("Update item for serial",
                        PartnerProceduresWizardUpdateItemForSerialComponent));
            } else if (event.value === "serial-to-qty") {
                this.steps.push(
                    new WizardStepFactory("Convert serial based item to quantity based",
                        PartnerProceduresWizardSerialToQtyComponent));
            } else if (event.value === "item-batch") {
                this.steps.push(
                    new WizardStepFactory("Update item batch/lot/rev",
                        PartnerProceduresWizardUpdateBatchComponent));
            } else if (event.value === "item-change-configuration") {
                this.steps.push(
                    new WizardStepFactory("Update configuration for serial",
                        PartnerProceduresWizardUpdateConfigurationForSerialComponent)
                );
            } else if (event.value === "unlink-serial-from-box") {
                this.steps.push(
                    new WizardStepFactory("Unlink Serial from box",
                        PartnerProceduresWizardUnlinkSerialFromBoxComponent)
                );
            } else if (event.value === "link-serial-to-box") {
                this.steps.push(
                    new WizardStepFactory("Link serial to box",
                        PartnerProceduresWizardLinkSerialToBoxComponent)
                );
            } else if (event.value === "box-ref-change") {
                this.steps.push(
                    new WizardStepFactory("Box ref update",
                        PartnerProceduresWizardBoxRefChangeComponent)
                );
            } else if (event.value === "pallet-ref-change") {
                this.steps.push(
                    new WizardStepFactory("Pallet ref update",
                        PartnerProceduresWizardPalletRefChangeComponent)
                );
            } else if (event.value === "pallet-location") {
                this.steps.splice(1);
                this.steps.push(
                    new WizardStepFactory("Scan pallet",
                        PartnerProceduresWizardTransferUpdatePalletComponent
                    ));
            } else if (event.value === "pallet-hub") {
                this.steps.splice(1);
                this.steps.push(
                    new WizardStepFactory("Scan pallet",
                        PartnerProceduresWizardUpdatePalletHubComponent
                    ));
            }

            setTimeout(() => {
                this.stepper.next();
            }, 500);
        }
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.data.wizardType = "procedures";

        this.getPartnerMrbs().then(() => {
            let groups = [
                {
                    options:
                        [
                            {
                                name: "Add Serial item to stock",
                                value: "serial-add"
                            },
                            {
                                name: "Remove Serial item from stock",
                                value: "serial-remove"
                            },
                            {
                                name: "Change Serial for item in stock",
                                value: "serial-change"
                            },
                            {
                                name: "Change Part Number for Serial item in stock",
                                value: "item-change-serial"
                            },
                            {
                                name: "Convert Serial item to a quantity managed item",
                                value: "serial-to-qty"
                            },
                            {
                                name: "Change Configuration for Serial item in stock",
                                value: "item-change-configuration"
                            },
                            {
                                name: "Unlink Serial from box",
                                value: "unlink-serial-from-box"
                            },
                            {
                                name: "Link serial to box",
                                value: "link-serial-to-box"
                            }
                        ],
                    group: "Items managed by Serial"
                },

                {
                    options:
                        [
                            {
                                name: "Change Part Number for Non Serial item in stock",
                                value: "item-change"
                            },
                            {
                                name: "Change Qty in stock for Non Serial item",
                                value: "quantity-change"
                            },
                            {
                                name: "Move Serial/ Non serial item between Sub inventories",
                                value: "hub-change"
                            }
                        ],
                    group: "Items managed by Qty"
                },

                {
                    options: [
                        {
                            name: "Update item Batch/Lot/Rev",
                            value: "item-batch"
                        }
                    ],
                    group: "Other procedures for items"
                },

                {
                    options: [
                        {
                            name: "Move boxes between Sub inventories",
                            value: "box-hub-change"
                        },
                        {
                            name: "Box Ref change",
                            value: "box-ref-change"
                        },
                        {
                            name: "Pallet Ref change",
                            value: "pallet-ref-change"
                        },
                        {
                            name: "Update pallet location",
                            value: "pallet-location",
                            default: true
                        },
                        {
                            name: "Update pallet sub inventory",
                            value: "pallet-hub",
                            default: false
                        },
                    ],
                    group: "Packages manage"
                }
            ];

            const filteredGroups: any[] = groups.map((group: any) => {
                group.options = group.options.filter(option =>
                    this.allowed_mrbs.includes(option.value)
                );


                return group;
            });

            groups = filteredGroups.filter(group => group.options.length > 0);

            this.steps.push(
                new WizardStepFactory("Scan type", PartnerProceduresWizardTypeComponent,
                    false, null, null, {groups}));

            setTimeout((): void => {
                this.stepper.selectedIndex = 0;
                this.handleStepChanges();
            }, 10);
        });


    }

    public ngConfig(): Base.IConfig {
        return {
            name: "procedures",
            actions: {
                "browse": ["read_reports"],
                "wizard": ["read_reports"],
            }
        };
    }

}
